import { Header } from '@cloudscape-design/components';
import { uploadPartFromFirestore } from '@parallel-fluidics/shared/models/parts';
import {
  collection,
  getFirestore,
  orderBy,
} from 'firebase/firestore';
import React, { useMemo } from 'react';

import PartsList from '../../components/PartsList';
import useSortParts from '../../components/PartsList/useSortParts';
import useCustomInfiniteQuery from '../../hooks/use-customInfiniteQuery';

function PartsListPage() {
  const { partsSort, setPartsSort } = useSortParts();

  const partsQueryParams = useMemo(() => [
    collection(getFirestore(), 'parts'),
    orderBy(partsSort.field, partsSort.isDescending ? 'desc' : 'asc'),
  ], [partsSort]);

  const {
    CustomPagination,
    pageData,
    isFetchingNextPage,
  } = useCustomInfiniteQuery({
    queryKey: 'getPartsData',
    queryParams: partsQueryParams,
    pageSize: 50,
    transformData: uploadPartFromFirestore,
  });

  return (
    <PartsList
      header={<Header variant="awsui-h1-sticky">Uploads</Header>}
      variant="full-page"
      parts={pageData}
      isLoading={isFetchingNextPage}
      Pagination={<CustomPagination />}
      // remote sorting props
      sorting={partsSort}
      onSortingChange={setPartsSort}
    />
  );
}

export default PartsListPage;
